import React from 'react';
import EnergyEntriesStep from './EnergyEntriesStep';
import { useLanguage } from '../../context/LanguageContext';

export const StepUsage = ({ formData, setFormData, energyFactors, addEntry, updateEntry, removeEntry, isDark, language, categories }) => {
  const { t } = useLanguage();
  return (
    <EnergyEntriesStep
      phase="usage"
      title={t('productWizard.usage.title')}
      subtitle={t('productWizard.usage.subtitle')}
      formData={formData} setFormData={setFormData}
      energyFactors={energyFactors} addEntry={addEntry} updateEntry={updateEntry} removeEntry={removeEntry}
      isDark={isDark} language={language} categories={categories}
      showCycles
    />
  );
};
